import React from 'react';
import { Toast } from 'react-native-toast-notifications';

import { StatusToast } from '@components/CustomToast/StatusToast.web';
import { Theme } from '@themes/theme';

// Longer than the 3s success toasts: the connection-issue copy is a full
// sentence the user has to act on, not just acknowledge.
export const SUBMIT_ERROR_TOAST_MS = 4000;

/**
 * Web error toast for a failed form submit (create project / create task).
 * Web uses this instead of `Alert.alert`, which is a blocking window.alert()
 * there, and instead of a modal the user has to dismiss before retrying.
 */
export const showSubmitErrorToast = (
  message: string,
  options?: { iconColor?: keyof Theme['colors'] }
) => {
  // Retrying a failing submit would otherwise stack one toast per attempt —
  // same reason ServerErrorToast.web hides all before showing.
  Toast.hideAll();
  Toast.show(
    <StatusToast
      message={message}
      duration={SUBMIT_ERROR_TOAST_MS}
      type='error'
      iconColor={options?.iconColor}
    />,
    {
      type: 'custom',
      duration: SUBMIT_ERROR_TOAST_MS,
      placement: 'bottom',
      animationType: 'slide-in',
      style: {
        backgroundColor: 'transparent',
        shadowColor: 'transparent',
      },
    }
  );
};
